import type { Player } from "./player";
import { Solidifier } from "./weapons/solidifier";
import { CryoGun } from "./weapons/cryoGun";
import { Cleaver } from "./weapons/cleaver";
import { Medikit } from "./items/medikit";
import { CAVES_LEVEL_START } from "./levelgenerator/prodLevelGenerator";

export interface CharacterDef {
	id: string;
	nameKey: string;
	descriptionKey: string;
	unlockAtLevel: number | null;
	unlockHintKey: string | null;
	loadoutIconKeys: string[];
	applyLoadout(player: Player): void;
}

export const DEFAULT_CHARACTER_ID = "green";

export const CHARACTERS: CharacterDef[] = [
	{
		id: "green",
		nameKey: "char_green_name",
		descriptionKey: "char_green_desc",
		unlockAtLevel: null,
		unlockHintKey: null,
		loadoutIconKeys: [Solidifier.key],
		applyLoadout(player: Player): void {
			player.addWeaponToArsenal(new Solidifier(player));
		},
	},
	{
		id: "blue",
		nameKey: "char_blue_name",
		descriptionKey: "char_blue_desc",
		unlockAtLevel: 5,
		unlockHintKey: "char_blue_unlockHint",
		loadoutIconKeys: [CryoGun.key],
		applyLoadout(player: Player): void {
			player.addWeaponToArsenal(new CryoGun(player));
		},
	},
	{
		id: "red",
		nameKey: "char_red_name",
		descriptionKey: "char_red_desc",
		unlockAtLevel: CAVES_LEVEL_START,
		unlockHintKey: "char_red_unlockHint",
		loadoutIconKeys: [Cleaver.key, Medikit.key],
		applyLoadout(player: Player): void {
			player.addWeaponToArsenal(new Cleaver(player));
			player.inventory.addItem(new Medikit(2));
		},
	},
];

export function getCharacterDef(id: string): CharacterDef | null {
	return CHARACTERS.find((def) => def.id === id) ?? null;
}

export function isCharacterUnlocked(def: CharacterDef, maxLevelReached: number): boolean {
	return def.unlockAtLevel === null || maxLevelReached >= def.unlockAtLevel;
}

export function getNewlyUnlockedCharacters(previousMax: number, newMax: number): CharacterDef[] {
	return CHARACTERS.filter(
		(def) => def.unlockAtLevel !== null && previousMax < def.unlockAtLevel && newMax >= def.unlockAtLevel,
	);
}
